import { render, staticRenderFns } from "./refonte-site-internet.vue?vue&type=template&id=6de94a9a&scoped=true&"
import script from "./refonte-site-internet.vue?vue&type=script&lang=js&"
export * from "./refonte-site-internet.vue?vue&type=script&lang=js&"
import style0 from "./refonte-site-internet.vue?vue&type=style&index=0&id=6de94a9a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de94a9a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Scroll: require('/app/components/Scroll.vue').default,Button: require('/app/components/Button.vue').default,FaqRefonte: require('/app/components/FaqRefonte.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
